<template>
    <div>
        <div class="filter-container">
            <el-select @change="getImportList" v-model="listQuery.sourceApp" filterable clearable @clear="clearEmpty('sourceApp')" :placeholder="$t('commons.appName')">
                <el-option
                        v-for="item in appList"
                        :key="item.itemCode"
                        :value="item.itemCode"
                        :label="item.itemName">
                </el-option>
            </el-select>
            <el-input :placeholder="$t('commons.searchPhrase')" v-model="listQuery.searchPhrase" clearable
                      maxlength="50"
                      style="width: 200px;" class="filter-item" @keyup.enter.native="getImportList"/>
            <el-button class="filter-item" type="primary" icon="el-icon-search" :loading="loading" @click="getImportList">
                {{$t('commons.search') }}
            </el-button>
        </div>
        <el-table v-loading="loading"
                :data="importList"
                element-loading-text="Loading"
                border
                fit
                highlight-current-row
                stripe>
            <el-table-column align="center" :label="$t('commons.fileName')">
                <template slot-scope="scope">
                    <el-button type="text" @click="downImportFile(scope.row)">{{ scope.row.fileName }}</el-button>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('commons.type')" width="100">
                <template slot-scope="scope">
                    <span>{{ scope.row.typeId }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('commons.status')" width="100">
                <template slot-scope="scope">
                    <span>
                        <template v-if="scope.row.importStatus == 0">
                            {{$t('commons.reading')}}
                        </template>
                        <template v-if="scope.row.importStatus == 1">
                            {{$t('commons.importing')}}
                        </template>
                        <template v-if="scope.row.importStatus == 2">
                            {{$t('order.completed')}}
                        </template>
                        <template v-if="scope.row.importStatus == 3">
                            {{$t('commons.cancelled')}}
                        </template>
                        <template v-if="scope.row.importStatus == 4">
                            {{$t('clocky.jobTraceStatus0')}}
                        </template>
                    </span>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('commons.errMsg')">
                <template slot-scope="scope">
                    <span>{{ scope.row.errorMsg  }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('commons.appName')" width="120">
                <template slot-scope="scope">
                    <span>{{ scope.row.sourceApp }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('commons.startTime')" width="160">
                <template slot-scope="scope">
                    <span>{{ scope.row.runStartTime | dateFormat("YYYY-MM-DD HH:mm:ss") }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('import.remark')">
                <template slot-scope="scope">
                    <el-button type="text" @click="downImportErrorFile(scope.row)">{{ scope.row.remark }}</el-button>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('commons.actions')" width="80">
                <template slot-scope="scope">
                    <el-tooltip :content="$t('commons.delete')">
                        <el-button
                                @click="deleteImportRecord(scope.row)"
                                circle
                                type="danger"
                                icon="el-icon-delete"
                                size="mini">
                        </el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.current"
                    :limit.sync="listQuery.rowCount"
                    @pagination="getImportList"/>
    </div>
</template>

<script>
    let manager = require("@/api/iori/my/import.js")
    import Pagination from '@/components/Pagination'

    export default {
        name: 'ImportList',
        components: {Pagination},
        data() {
            return {
                appList:[],
                importList: null,
                loading: false,
                total: 0,
                listQuery: {
                    current: 1,
                    rowCount: 10,
                    sourceApp:null,
                    searchPhrase: undefined,
                }
            }
        },
        created() {
            this.getImportList()
            this.getAppList()
        },
        methods: {
            getAppList(){
                manager.findAppList({classifyCode: 'APP_LIST'}).then((r)=> {
                    this.appList = r;
                })
            },
            getImportList() {
                this.loading = true
                manager.getImportList(this.listQuery).then(response => {
                    this.importList = response.rows;
                    this.total = response.total;
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
                    console.log(`查询失败，原因 => ${error}`)
                })
            },
            deleteImportRecord(row) {
                this.$confirm(this.$t('message.deleteConfirm'),this.$t('commons.warning'),{
                    confirmButtonText:this.$t('commons.confirm'),
                    cancelButtonText:this.$t('commons.cancel'),
                    type:'warning'
                }).then(()=>{
                    manager.delImportRecord(row).then(() => {
                        this.$message({
                            type: 'success',
                            message: this.$t('message.deleteSuccess')
                        });
                        this.getImportList()
                    }).catch(() => {})
                })
            },
            downImportFile(row) {
                manager.downImportExcel(row.taskId, row.downloadUrl)
            },
            downImportErrorFile(row) {
                manager.downErrorExcel(row.taskId, row.downloadUrl);
            },
            clearEmpty(field) {
                this.listQuery[field] = null
            }
        }
    }
</script>
